/**
 * The reference lists the Add enquiry form picks from.
 *
 * Three lists — Title, Life style and the Goal field's — because those are the
 * three fields `POST /api/v1/inquiries/add/` takes as ids rather than as text.
 * Gender, Profession and Enquiry from stay in `enquiryFormOptions`: the
 * endpoint takes those as they are written.
 *
 * The Goal field reads `serviceGoals`, which is the practice's own active
 * services, rather than the backend's goal catalog: an enquiry is raised
 * against something the practitioner offers, and what goes up is the service's
 * `public_id`. The client form's Goal field is fed the same way.
 *
 * The same machinery the Add client form uses, asked for a smaller set — see
 * `useCatalogLookups`.
 */

import { useCatalogLookups } from "../../clients/hooks/useCatalogLookups";
import type { CatalogLookups } from "../../clients/hooks/useCatalogLookups";

/**
 * Module-level and never rebuilt: the hook keys its fetch on these names, and
 * a fresh array per render would be a fresh set of requests per keystroke.
 */
const ENQUIRY_CATALOGS = ["titles", "serviceGoals", "lifeStyles"] as const;

export type EnquiryLookupName = (typeof ENQUIRY_CATALOGS)[number];

/** Exported so the form can report which of them failed without naming each. */
export const ENQUIRY_LOOKUP_NAMES: readonly EnquiryLookupName[] =
  ENQUIRY_CATALOGS;

export type EnquiryLookups = CatalogLookups<EnquiryLookupName>;

export function useEnquiryLookups(): EnquiryLookups {
  return useCatalogLookups(ENQUIRY_CATALOGS);
}
